export default {
  "1": (ctx) => {const { normalize: _normalize } = ctx;return _normalize(["Informazioni di registrazione"])},
  "2": (ctx) => {const { normalize: _normalize } = ctx;return _normalize(["Salva dati"])},
  "3": (ctx) => {const { normalize: _normalize } = ctx;return _normalize(["Confermato"])},
  "4": (ctx) => {const { normalize: _normalize } = ctx;return _normalize(["Questo campo è pubblico e visibile agli altri utenti"])},
  "5": (ctx) => {const { normalize: _normalize } = ctx;return _normalize(["Questo campo è nascosto agli altri utenti"])},
  "6": (ctx) => {const { normalize: _normalize } = ctx;return _normalize(["Verifica dell'identità"])},
  "7": (ctx) => {const { normalize: _normalize } = ctx;return _normalize(["Verificato"])},
  "8": (ctx) => {const { normalize: _normalize } = ctx;return _normalize(["In corso"])},
  "9": (ctx) => {const { normalize: _normalize } = ctx;return _normalize(["Non verificato"])},
  "10": (ctx) => {const { normalize: _normalize } = ctx;return _normalize(["Avvia verifica"])}
}